import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useComponentConfig } from 'js/hooks/component';

export const useGetNavigationParams = () => {
    const { search } = useLocation();
    const { navigationParameters } = useComponentConfig();

    return useMemo(() => {
        let getParamsFromURL = null;
        const searchParams = new URLSearchParams(search);
        const configSearchParams = navigationParameters ? Object.fromEntries(new URLSearchParams(navigationParameters)) : null;

        searchParams.forEach((value, key) => {
            if (/^bc/.test(key)) {
                getParamsFromURL = getParamsFromURL || {};
                getParamsFromURL[key.substring(2)] = value;
            }
        });

        return {
            ...getParamsFromURL || configSearchParams || {}
        };
    }, [search, navigationParameters]);
};
